// extracted by mini-css-extract-plugin
module.exports = {"mark":"_1Hl8p"};